export default __webpack_public_path__ + "img/app.812a74d5.png";